export enum EmploymentFormTypeEnum {
    OnSite = 1,
    WorkFromHome = 2,
    Hybrid = 3,
    Field = 4
  }